import React from "react";

interface Number {
  [key: string]: string;
}

interface DollieNames {
  [key: string]: Number;
}

interface DollieYears {
  pages: DollieNames[];
}

const dollieData: DollieYears = {
  pages: [
    {
      "1954-1955": {
        "1": "Emmy Badger Ames",
        "2": "Judy Babb",
        "3": "Sally Sloan Jordan",
        "4": "Pat Siler Lowe",
        "5": "Kay Osbourn",
        "6": "Katie Seaver",
        "7": "Lynn Sellman",
      },
      "1956-1957": {
        "1": "Sally Wolfe Dole",
        "2": "Joni Balling Rehnborg",
        "3": "Deanna Amos Tarr",
        "4": "Maureen O'Brien Sullivan",
        "5": "Linda Player Kaiser",
      },
      "1957-1958": {
        "1": "Sonya Davidson Lamb",
        "2": "Sandy Hogan",
        "3": "Connie King Turkington",
        "4": "Luana Gough",
        "5": "Margi Mix Gould",
      },
      "1958-1959": {
        "1": "Barbara L. Baer",
        "2": "Caryl (Ely) Chambers",
        "3": "Rosemary Dedman",
        "4": "Carole (Erickson) Halsted",
        "5": "Nancy (Viets) Merrill",
      },
      "1959-1960": {
        "1": "Susie Berger",
        "2": "Nancy (Hughes) Daley",
        "3": "Nancy (Lee) Hanna",
        "4": "Judy (Kehoe) McKibben",
        "5": "Nancy Young",
      },
      "1960-1961": {
        "1": "Wendy (Anderson) Bianchi",
        "2": "Patricia (Murman) Burbank",
        "3": "Kathleen (Page) Elliott",
        "4": "Lana (Caffey) Hayward",
        "5": "Suzanne (Horney) L. Sheppard",
      },
      "1961-1962": {
        "1": "Mary Dicky Barkley",
        "2": "Diana (Deasy) Creighton",
        "3": "Toni (Williamson) Croft",
        "4": "Susie (Quigley) Matthews",
        "5": "Judy Webb",
      },
      "1962-1963": {
        "1": "Nancy (Albert ) Albert-James",
        "2": "Lynn (Cipolat) Archer",
        "3": 'Virginia "Ginger" (Bilder) Bell',
        "4": "Barbara (Glidden) Dray",
        "5": "Jacquelynne F. Jackson",
      },
      "1963-1964": {
        "1": "Elaine E. Hill",
        "2": "Martha (Crummey) Parriott",
        "3": "Barbara (Burns) Tepper",
        "4": "Ellen (Jung) Whitmore",
        "5": "Jacqueline Laney Florsheim",
      },
      "1964-1965": {
        "1": '"Winki" Belz',
        "2": "Freddie A. (Baumstark) Jackson",
        "3": "Susan T. Janss",
        "4": 'Margaret "Peggy" (Eaton) Miller',
        "5": "Lynn Williams Twist",
      },
      "1965-1966": {
        "1": "Laura (Grant) Gamble",
        "2": "Annabelle (Evans) Nye",
        "3": "(Aya) Louisa McDonald",
        "4": "Jonell (Friedkin) Monschke",
        "5": "Janet (Hardy) Willson",
      },
      "1966-1967": {
        "1": "Susan Bailey Blunt",
        "2": "Kathy Gerson",
        "3": "Barbara (Range) Oar",
        "4": "Jackie (Fergusson) Sacco",
        "5": "Susan (Hayduk) Siebert",
      },
      "1967-1968": {
        "1": "Jennifer Sue Bond",
        "2": "Nancy H. Kerr",
        "3": 'Eleanor "Ellie" (Watkins) Laney',
        "4": "Susan (McCann) Messer",
        "5": "Patricia Susan (Beck) Parmely",
        "6": "Susan Phillips",
      },
      "1968-1969": {
        "1": 'Barbette "Barbi" (Feller) Dauliner',
        "2": "Teresa (Cady) Deane",
        "3": "Cheri (Dyck) Micheletti",
        "4": 'Virginia "Ginger" (Butts) Radlo',
        "5": "Melissa (Toney) Sullivan",
      },
      "1969-1970": {
        "1": "Cathleen Caballero",
        "2": "Kathleen (McKenna) Carter",
        "3": "Chistine Eskola-Feig",
        "4": "Diane (Fields) Geocaris",
        "5": "Linda (Wright) Moore",
      },
      "1970-1971": {
        "1": 'Irene "Reeni" Maharam Boyd',
        "2": 'Maria "Mary" Hernandez Gass',
        "3": "Jeannette (Jones) Y.J. Heidrich",
        "4": "Susie Peterson (aka Leef Kedi)",
        "5": "Susan Taylor Kistler",
      },
      "1971-1972": {
        "1": "Laura (Simon) Rung",
        "2": "Sheri (Cooper) Sinykin",
        "3": "Christina (Hwang) Madison",
        "4": "Daryl (Wood) Wood-Gerber",
        "5": "Linda (Mitchell) Sanderson",
      },
      "1972-1973": {
        "1": "Charmaine Berry",
        "2": "Irene (Balcar) Dillon",
        "3": "Susan (Myers) DePrez",
        "4": "Jill (Kostenko) Fogelsong",
        "5": "Kerr McGuinn",
      },
      "1973-1974": {
        "1": "Marcella (Deffke) Harrison",
        "2": "Jacki (Nelson) Williams-Jones",
        "3": "Stephanie (Jubina) Baker",
        "4": "Linda Jenks",
        "5": "Linda (Thomas) Brigleb",
      },
      "1974-1975": {
        "1": "Terry (Bowman) Gilberg",
        "2": "Hilda Hutcherson",
        "3": "Denise (Gallardo) McKenna-Doyen",
        "4": "Loretta (Churchill) Miramontes",
        "5": "Linda (Buddenberg) Reed",
      },
      "1975-1976": {
        "1": 'Antonia "Toni" Hunter Breck',
        "2": "Linda Bridgford Gantes",
        "3": "Bonnie McColl Platt",
        "4": 'Teresa "Terry" Elms Lindsay',
        "5": "Katherine (Cannell) Wright",
      },
      "1976-1977": {
        "1": "Cathie Pelton",
        "2": "Lynn Preslo",
        "3": "Carla Murray",
        "4": "Carrie Teagle",
        "5": "Heidi Jacobson",
      },
      "1977-1978": {
        "1": "Elena (Camacho) Beyers",
        "2": "Jane (Dorst) Clark",
        "3": "Simone B. Cox",
        "4": "Nancy (Schorr) Epstein",
        "5": "Beth (Buell) Schoenstein",
      },
      "1978-1979": {
        "1": "Pamela Guzy",
        "2": "Jonrie Etchemendy Davila",
        "3": "Anna Maria (Guerra) Fairhurst",
        "4": "Gayle McGinnis",
        "5": "Ronda Spinak",
      },
      "1979-1980": {
        "1": "Jayne (Sherry) Mordell",
        "2": "Terrie (Oppelt) Preising",
        "3": "Trinka (Gayle Wasik",
        "4": "Wendy Scroggin",
        "5": "Carol Gamez",
      },
      "1980-1981": {
        "1": "Didi Justin-Reed",
        "2": "Clare (Colwell) Humphrey",
        "3": "Hilary (Hall) Bartels",
        "4": "Lenita Williamson",
        "5": "Dana Fugelso",
      },
      "1981-1982": {
        "1": "Helene (Duhamel) Duffy",
        "2": "Karol Watson",
        "3": "Gina (Davis) Carroll",
        "4": "Nancy Branch",
        "5": "Mary Lee MacKichan",
      },
      "1982-1983": {
        "1": "Diana Dobbs Melton",
        "2": "Melinda Myers Cook",
        "3": "Gina Moreno John",
        "4": "Betsy DePalma Sperry",
        "5": "Sue Cameron McDonald",
      },
      "1983-1984": {
        "1": "Marisa Butler-Brown",
        "2": "Debbi (Reza) Christiansen",
        "3": "Julie (Clinton) Quinn",
        "4": "Karen (Hanst) Vesey",
        "5": "Carolyn Weisz",
      },
      "1984-1985": {
        "1": "Kelly Colbert",
        "2": "Brenda (Branin) Beck",
        "3": "Kathy (Lowe) Knowles",
        "4": "Monica (Lytle) Lyle",
        "5": "Ellen (Rosenthal) Mouchawar",
      },
      "1985-1986": {
        "1": "Jeanine (Gaylord) Mouchawar",
        "2": "Susan (Inge) Callahan",
        "3": "Laurie (Elliott) Croft",
        "4": "Anne O'Brien",
        "5": "Arija Bareikis",
      },
      "1986-1987": {
        "1": "Vicky (Takatsuka) Cleaveland",
        "2": "Dineen (Johnson) Greer",
        "3": "Lisa Larragoite",
        "4": "Julie Nasif Litle",
        "5": "Katie (Genshlea) Paris",
      },
      "1987-1988": {
        "1": 'Diedre "Dee" (Cohen) Katz',
        "2": "(Laura) Ashley McLain",
        "3": "Patty Flam",
        "4": "Shelley (Gin) Lee",
        "5": "Anne (Chun) Longo",
      },
      "1988-1989": {
        "1": "Sheeri (Caldwell) Mitchell",
        "2": "Rachel Croft",
        "3": "Shannon Keel",
        "4": "Marsi (Lindersmith) Gorman",
        "5": "Patti Williams",
      },
      "1989-1990": {
        "1": "Emily (Mackenzie) Brakebill",
        "2": "Meghan Mackay (Thorpe)",
        "3": "Juli Oh",
        "4": "Dionn (Stewart) Shaffner",
        "5": "Mary (Gehan) Steele",
      },
      "1990-1991": {
        "1": "Noelle (Kovach) Chapin",
        "2": "Sun Kim",
        "3": "Denise S. Martinez",
        "4": "Ashanti D. Trent",
        "5": "Celene (Soto) Voyles",
      },
      "1991-1992": {
        "1": "Debbie Bain Brickley",
        "2": "Heidi Gilman Bennett",
        "3": "Diana Kraft",
        "4": "Kristie Marks deBusschere",
        "5": "Julie (Carter) Servoss",
      },
      "1992-1993": {
        "1": "Felicia Khoja",
        "2": "Michelle Avril",
        "3": "Vivienne Hsy",
        "4": "Sondra Ward",
        "5": "Erin (Cutler) Clausen",
      },
      "1993-1994": {
        "1": "Heidi Hwong",
        "2": 'Sangini "Gini" Majmudar',
        "3": 'Elizabeth "Lizzie" Sayner',
        "4": "Karen L. Simon",
        "5": "Tiffany D. Trotter",
      },
      "1994-1995": {
        "1": "Vanessa Arrington",
        "2": "Rachel (Barnett) Peters",
        "3": "Yu-Jin Kim",
        "4": "Jenny Nelson",
        "5": "Jody Thomas",
      },
      "1995-1996": {
        "1": "Stephanie Pieczenik",
        "2": "(Amy) Jo Chien",
        "3": "Erin (Cavalli) Duran",
        "4": "Shaine (Muller) Morris",
        "5": "Julie Cuevas",
      },
      "1996-1997": {
        "1": "Corinne Chapman",
        "2": "Brittney Jensen",
        "3": "Lindsay Mazotti",
        "4": "Tracey McLean",
        "5": 'Jennifer "Jenn" Pfotenauer',
      },
      "1997-1998": {
        "1": "Reiko Osaki",
        "2": "Michelle Tsuda",
        "3": "Mickayela Beatty",
        "4": "Emily Roley",
        "5": "Becky Novotny",
      },
      "1998-1999": {
        "1": "Lizzie (Barnett) Sargeant",
        "2": 'Glory "Lani" Leilani Ludwick',
        "3": "Lynn Chiu",
        "4": "Wendy Marinaccio",
        "5": "Helen Lily Huang",
      },
      "1999-2000": {
        "1": "Maria Reese",
        "2": "Shiao Chen",
        "3": "Campbell Miller",
        "4": "Esther Cohen",
        "5": "Rhiannon Meier",
      },
      "2000-2001": {
        "1": "Jenny Steiger",
        "2": "Amanda Ose",
        "3": "Lisa Hladik",
        "4": "Yael Schrager",
        "5": "Pamela Jones",
      },
      "2001-2002": {
        "1": "Nikki Borchardt",
        "2": "Amy Kurren",
        "3": "Lauren Uyeshiro",
        "4": "Veronica Flores",
        "5": "Emma James",
      },
      "2002-2003": {
        "1": "Valerie Rozycki",
        "2": "Erin Christofferson",
        "3": "Nevenka Mattenet",
        "4": "Malia Skaer",
        "5": "Marisa Dye",
      },
      "2003-2004": {
        "1": "Melanie Atmadja",
        "2": "Veronica Spindler",
        "3": "Tracy Conner",
        "4": "Clare Tobin",
        "5": "Michelle Miller",
      },
      "2004-2005": {
        "1": "Megan Hoarfrost",
        "2": "Lisa Asari",
        "3": "Nicole D'arcy",
        "4": "Jessica (Whitten) Gustafson",
        "5": "Carrie Edwards",
      },
      "2005-2006": {
        "1": "Maili Alvarado",
        "2": "Lauri Anderson",
        "3": "Liz Schackmann",
        "4": "Katie Ambrose",
        "5": "Stacie Vilendrer",
      },
      "2006-2007": {
        "1": "Brittiany Broadwater",
        "2": "Amy Kurzweil",
        "3": "Annemarie Estess",
        "4": "Lauren Smith",
        "5": "Abby Williams",
      },
      "2007-2008": {
        "1": "Jessica Finley",
        "2": "Katie Peterson",
        "3": "Christina Landry",
        "4": "Jessica Murphy",
        "5": "Maddie Graber",
      },
      "2008-2009": {
        "1": "Jennifer Lee",
        "2": "Ali Romer",
        "3": "Taylor Phillips",
        "4": "Sydney Gulbronson",
        "5": "Taylor Thibodeaux",
      },
      "2009-2010": {
        "1": "Shea Ritchie",
        "2": "Paula Markey",
        "3": "Nia Minor",
        "4": "Kim Souza",
        "5": "Elise Birkhofer",
      },
      "2010-2011": {
        "1": "Alina Pimentel",
        "2": 'Carolyn "CC" Chiu',
        "3": "Sarah Chang",
        "4": "Melissa Schwarz",
        "5": "Alex Nana-Sinkam",
      },
      "2011-2012": {
        "1": "Paula Obler",
        "2": "Jessica Jin",
        "3": "Clare Bailey",
        "4": "Jessica Savoie",
        "5": "Danna Seligman",
      },
      "2012-2013": {
        "1": "Tayna Gonzalez",
        "2": "Emily Giglio",
        "3": "Dafna Szafer",
        "4": "Amber Quiñones",
        "5": "Christine Chung",
      },
      "2013-2014": {
        "1": "Lindsay Fiorentino",
        "2": "Heather Glenny",
        "3": "Leigh Kinney",
        "4": "Courtney Yang",
        "5": "Amelia Chen",
      },
      "2014-2015": {
        "1": "Erika Nguyen",
        "2": "Aubriana Menendez",
        "3": "Martha Collins",
        "4": "Avianna Mynhier",
        "5": "Jordan Huelskamp",
      },
      "2015-2016": {
        "1": "Alida Ratteray",
        "2": "Claudia Aber",
        "3": "Chloe Koseff",
        "4": "Shelby Crants",
        "5": "Dalia Szafer",
      },
      "2016-2017": {
        "1": "Janelle Kaneda",
        "2": "Arianna Tapia",
        "3": "Taylor Butze",
        "4": "Jolena Ma",
        "5": "Emily O'Neal",
      },
      "2017-2018": {
        "1": "Grace Dong",
        "2": "Audrey Elliott",
        "3": "Samantha Loui",
        "4": "Lauren Clark",
        "5": "Sydney Maly",
      },
      "2018-2019": {
        "1": "Justine Kaneda",
        "2": "Erica Olsen",
        "3": "Ellie Toler",
        "4": "Sabrina Medler",
        "5": "Sarah Ludington",
      },
      "2019-2020": {
        "1": "Charlotte Brewer",
        "2": "Jasmine Rodriguez",
        "3": "Tiffany Liu",
        "4": "Julia Raven",
        "5": "Savannah Payne",
      },
      "2020-2022": {
        "1": "Amisha Iyer",
        "2": "Annabelle Wang",
        "3": "Yishu Chen",
        "4": "Vivian Urness",
        "5": "Audrey Ward",
      },
      "2022-2023": {
        "1": "Karina Chen",
        "2": "Sophia Chun",
        "3": "Emma Wang",
        "4": "Alyssa Frederick",
        "5": "Chuyi Zhang",
      },
      "2023-2024": {
        "1": "Cheryl Tolomeo",
        "2": 'Rachel "Mack" Jones',
        "3": "Cordelia Li",
        "4": "Eva Geierstanger",
        "5": "Ava Tiffany",
      },
      "2024-2025": {
        "1": "Ariana Lee",
        "2": "Alice Finkelstein",
        "3": "Yujen Lin",
        "4": "Janae Lindsay",
        "5": "Abigail Lee",
      },
      "2025-2026": {
        "1": "Samantha Lau",
        "2": "Makyla Cervantes",
        "3": "Talon Watchman",
        "4": "Rosalyn Tu",
        "5": "Corinne Thomas",
      },
      "2026-2027": {
        "1": "Shelley Guo",
        "2": "Lily Poon",
        "3": "Colette Chang",
        "4": "Ani Yordanova",
        "5": "Logan Christopher",
      },
    },
  ],
};

export default dollieData;
